import { View } from "@react-pdf/renderer";
import {
  ResumePDFSection,
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeLanguage } from "lib/redux/types";
import {
  ResumePDFDescriptionWithWhiteFont,
  TemplateEightLeftColumnSectionWithSubsections,
} from "./common";

export const Language = ({
  heading,
  languages,
  themeColor,
  isPDF,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  languages: ResumeLanguage[];
  themeColor: string;
  isPDF: boolean;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateEightLeftColumnSectionWithSubsections themeColor={themeColor} heading={heading}>
      {languages.map(({ language, level, descriptions }, idx) => (
        <View 
          key={idx} 
          wrap={false}
          style={idx !== 0 ? { marginTop: spacing["1"] } : {}} 
        >
          <View
            style={{
              ...styles.flexRow,
              gap: spacing["1"], // spacing["2"] 
              alignItems: "center",
            }}
          >
            <ResumePDFText themeColor="white" bold={true}>
              {language}:
            </ResumePDFText>
            <ResumePDFText themeColor="white">{level}</ResumePDFText>
          </View>
          <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
            <ResumePDFDescriptionWithWhiteFont items={descriptions} enableHighlight={enableHighlight} enableMistakeHighlight={enableMistakeHighlight} section="languages" itemIndex={idx} />
          </View>
        </View>
      ))}
    </TemplateEightLeftColumnSectionWithSubsections>
  );
};
